export default {
  computed: {
    validIssueWeight() {
      return false;
    },
  },
  methods: {
    filterByWeight() {},
  },
};
